import React, { useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { QuotaSnapshot, getMySubscription } from '../../Services/SubscriptionService';

export interface SubscriptionQuotaCardHandle {
    refresh: () => Promise<void>;
}

const SubscriptionQuotaCard = forwardRef<SubscriptionQuotaCardHandle>((_props, ref) => {
    const [snapshot, setSnapshot] = useState<QuotaSnapshot | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchSnapshot = async () => {
        try {
            setLoading(true);
            const data = await getMySubscription();
            setSnapshot(data);
            setError(null);
        } catch (err: any) {
            setError(err?.response?.data?.error || err?.message || 'No se pudo cargar la suscripción');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSnapshot();
    }, []);

    useImperativeHandle(ref, () => ({
        refresh: fetchSnapshot,
    }));

    if (loading || error || !snapshot) {
        return null;
    }

    const isFull = snapshot.remaining === 0;
    const planLabel = snapshot.plan_name ?? 'Plan gratuito';
    const expires = snapshot.expires_at ? new Date(snapshot.expires_at).toLocaleDateString('es-ES') : null;

    return (
        <div
            className={`card mb-3 ${isFull ? 'border-danger' : ''}`}
            style={{ borderRadius: 8 }}
            title={isFull ? 'Contacta con tu administrador para ampliar tu plan' : undefined}
        >
            <div className="card-body py-3">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div>
                        <strong style={{ color: isFull ? '#c62828' : 'inherit' }}>
                            {snapshot.used}/{snapshot.limit} proyectos
                        </strong>
                        <span className="text-muted ms-2">· {planLabel}</span>
                    </div>
                    {expires && <small className="text-muted">Renovación: {expires}</small>}
                </div>
            </div>
        </div>
    );
});

SubscriptionQuotaCard.displayName = 'SubscriptionQuotaCard';

export default SubscriptionQuotaCard;
